import type { SenderPlatform } from '../services/api';

/** Nome de exibição das plataformas de login social do espectador. */
export const PLATFORM_LABEL: Record<SenderPlatform, string> = {
  twitch: 'Twitch',
  youtube: 'YouTube',
  kick: 'Kick',
};
